import { ShieldCheck, Lock, Award } from "lucide-react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";
import { fadeIn, staggerContainer, staggerItem } from "@/lib/animations";

const universities = ["Stanford", "MIT", "Harvard", "Oxford", "Berkeley"];

export function TrustBar() {
  return (
    <Section background="muted" className="py-12 md:py-16">
      <Container>
        <motion.p 
          className="text-center text-muted-foreground mb-8"
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Trusted by 500+ research teams worldwide
        </motion.p>
        
        {/* Placeholder for company logos - using text badges instead */}
        <motion.div 
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 items-center justify-items-center mb-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {universities.map((name) => (
            <motion.div
              key={name}
              className="text-lg font-semibold text-muted-foreground/60 hover:text-muted-foreground transition-colors cursor-default"
              variants={staggerItem}
              whileHover={{ scale: 1.05 }}
            >
              {name}
            </motion.div>
          ))}
        </motion.div>
        
        {/* Security badges */}
        <motion.div 
          className="flex flex-wrap justify-center gap-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div variants={staggerItem}>
            <Badge variant="secondary" className="text-xs hover:bg-secondary/80 transition-colors">
              <ShieldCheck className="h-3 w-3 mr-1" />
              SOC2 Compliant
            </Badge>
          </motion.div>
          <motion.div variants={staggerItem}>
            <Badge variant="secondary" className="text-xs hover:bg-secondary/80 transition-colors">
              <Award className="h-3 w-3 mr-1" />
              GDPR Ready
            </Badge>
          </motion.div>
          <motion.div variants={staggerItem}>
            <Badge variant="secondary" className="text-xs hover:bg-secondary/80 transition-colors">
              <Lock className="h-3 w-3 mr-1" />
              256-bit Encryption
            </Badge>
          </motion.div>
        </motion.div>
      </Container>
    </Section>
  );
}
